import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CareCreditEnrollDisclosureBody } from './care-credit-enroll-disclosure-body';
import { CareCreditEnrollDisclosureGenericNavigation } from './navigation/care-credit-enroll-disclosure-generic-navigation';

export const CareCreditEnrollDisclosureNavigationSwitch = () => {
  return (
    <StepNavigationSwitch body={CareCreditEnrollDisclosureBody} generic={CareCreditEnrollDisclosureGenericNavigation} />
  );
};
